import React from 'react'
import { tints } from '@manychat/manyui'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const EmptyContainerStyle: React.CSSProperties = sharedStyles.messengerBlockEmpty

export const ExternalContainerStyle: React.CSSProperties = {
  ...sharedStyles.messengerBlock,
  backgroundColor: tints.purple[6],
}

export const DefaultContainerStyle: React.CSSProperties = sharedStyles.messengerBlock

export const DelayContainerStyle: React.CSSProperties = {
  ...sharedStyles.systemBlock,
  padding: sharedStyles.messengerBlock.padding,
}

export const ConnectedToNextContainerStyle: React.CSSProperties = {
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}

export const ConnectedToPreviousContainerStyle: React.CSSProperties = {
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}
